// extracted by mini-css-extract-plugin
export default {"container":"Home_container__tvRnT","documentation":"Home_documentation__pSTxj"};